import { memo, useCallback, useMemo } from 'react';

import { Stack } from '@mui/system';
import { useAppStore } from '@/modules/app/store/useAppStore';
import { AppServiceFactory } from '@/modules/app/service/AppServiceFactory';

import { HoverToolbar } from './HoverToolbar';
import { actionItems, toolbarItems } from '../constants';
import { ToolId } from '../types';
import { UndoRedo } from './UndoRedo';
import { styles } from '../styles';

function ToolbarComponent() {
  const selectedToolId = useAppStore((state) => state.selectedToolId);
  const mode = useAppStore((state) => state.mode);
  const appSvc = useMemo(() => AppServiceFactory.getInstance().createAppService(), []);
  const activeModule = useAppStore((state) => state.activeModule);

  const activateTool = useCallback(
    (toolId: ToolId) => {
      appSvc.activateTool(toolId);
    },
    [appSvc],
  );

  const activeToolbarItems = useMemo(() => {
    if (activeModule === 'canvas_layout') {
      return toolbarItems;
    }

    if (activeModule === 'canvas_setup') {
      return actionItems;
    }

    return [];
  }, [activeModule]);

  return (
    <Stack style={styles.toolbarWrapper}>
      <HoverToolbar
        items={activeToolbarItems}
        selectedToolId={selectedToolId}
        onSelectTool={activateTool}
        disabled={mode !== 'EDITABLE'}
      />
      <UndoRedo />
    </Stack>
  );
}

export const Toolbar = memo(ToolbarComponent);
